import { render, staticRenderFns } from "./Capture.vue?vue&type=template&id=33a9f0c0&"
import script from "./Capture.vue?vue&type=script&lang=ts&"
export * from "./Capture.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/opt/build/repo/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VCol } from 'vuetify/lib'
import { VContainer } from 'vuetify/lib'
import { VProgressLinear } from 'vuetify/lib'
import { VRow } from 'vuetify/lib'
import { VSimpleTable } from 'vuetify/lib'
installComponents(component, {VBtn,VCol,VContainer,VProgressLinear,VRow,VSimpleTable})
